<ng-container *ngIf="friendWallets && friendWallets.fiat.list.length>0">
	<span class="wallet-type-title">{{'WALLET.FIAT_WALLETS' | translate}}</span>
	<div class="wallet-container" #wallets (resized)="onResized($event)">
		<tc-table-loading *ngIf="isLoading"></tc-table-loading>
		<div *ngFor="let item of friendWallets.fiat.list" [class]="'wallet selectable ' + walletClass"
			[ngClass]="{'selected': selectedWallet !== undefined && item.accountNumber === selectedWallet.accountNumber}"
			(click)="selectWallet(item)">
			<div class="wallet-content">
				<div class="icon-check-circle"></div>
				<div class="detail">
					<div class="wallet-icon">
						<i class="icon-wallet-vt"></i>
					</div>
					<div class="info">
						<div class="type">{{item.currencyCode}} {{'REQUEST.WALLET' | translate}}</div>
						<div class="number">{{item.accountNumber}}</div>
					</div>
					<div class="amount">
						<div class="number">**********</div>
						<!-- <div class="currency">{{item.currencyCode}}</div> -->
					</div>
				</div>
			</div>
		</div>

	</div>
</ng-container>

<ng-container *ngIf="showCrypto">
	<ng-container *ngIf="friendWallets && friendWallets.crypto.list.length>0">
		<span class="wallet-type-title">{{'WALLET.CRYPTO_WALLETS' | translate}}</span>
		<div class="wallet-container" (resized)="onResized($event)">
			<tc-table-loading *ngIf="isLoading"></tc-table-loading>
			<div *ngFor="let item of friendWallets.crypto.list" [class]="'wallet selectable ' + walletClass"
				[ngClass]="{'selected': selectedWallet !== undefined && item.accountNumber === selectedWallet.accountNumber}"
				(click)="selectWallet(item)">
				<div class="wallet-content">
					<div class="icon-check-circle"></div>
					<div class="detail">
						<div class="wallet-icon">
							<i class="icon-wallet-vt"></i>
						</div>
						<div class="info">
							<div class="type">{{item.currencyCode}} {{'REQUEST.WALLET' | translate}}</div>
							<div class="number">{{item.accountNumber}}</div>
						</div>
						<div class="amount">
							<div class="number">**********</div>
							<!-- <div class="currency">{{item.currencyCode}}</div> -->
						</div>
					</div>
				</div>
			</div>

		</div>
	</ng-container>
</ng-container>